import React from 'react';
import styled from 'styled-components';

const Footer = styled.div`
  border-top: 1px solid var(--Light-Gray, #e6e6e6);
  display: flex;
  padding: 20px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 20px;

  p {
    color: #000000;
    font-family: 'OCRoboto';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 128%;
  }
`;

export default ({ text }) => (
  <Footer>
    <p>{text}</p>
  </Footer>
);
